import React from 'react';
import styled from 'styled-components';
import { Spinner } from '../spinner/Spinner';

export interface LoadingIndicator {
    children?: React.ReactNode,
    className?: string;
}
/**
 * Use the `LoadingIndicator` to inform users about the status of ongoing processes, such as loading an app, submitting a form, or saving updates.
 * You can include any content, usually a message, as a child. If you do not provide one, the word "Loading" will be rendered in the component.
 */
export const LoadingIndicator = ({ children, className}: LoadingIndicator) => (
    <LoadingWrapper className={`position-relative d-flex align-items-center justify-content-center flex-column ${className}`}>
        <Spinner size="xl" />
        {children &&
            <LoadingText className="d-flex align-items-center justify-content-center flex-column">
                <p className="body-md">{children}</p>
            </LoadingText>
        }
    </LoadingWrapper>
);

LoadingIndicator.defaultProps = {
    children: 'Loading',
    className: '',
}

const LoadingWrapper = styled.div`
    height: 130px;
    width: 130px;
    &:after{
        content: '';
        min-height: inherit;
        font-size: 0;
    }
`;

const LoadingText = styled.div`
    position: absolute;
    height: 130px;
    width: 130px;
    top: 0;
    left: 0;
    padding: 20px;
    & p {
        font-weight: 400;
        text-align: center;
        color: #9e9e9e;
        color: var(--color-neutral-500);
        margin: 0;
        line-height: 1.1;
        width: 100%;
    }
`;
  
export default LoadingIndicator;